import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import VerticalDirectorHistoryLayer from '../components/VerticalDirectorHistoryLayer'

const VerticalDirectorHistoryPage = () => {
    return (
        <>
            <MasterLayout>
                <VerticalDirectorHistoryLayer />
            </MasterLayout>
        </>
    )
}

export default VerticalDirectorHistoryPage
